import { useCallback } from 'react';
import { selectObjectTypesList } from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import type { TTEObject } from '@timeedit/types';
import type { ObjectManagerDetailProps } from '../ObjectManagerDetail';
import { Association } from './Association';

const OptionalRelated = ({
  object,
  onChange,
  dirtyFields,
}: ObjectManagerDetailProps) => {
  const { optionalRelations } = object;
  const allType = useAppSelector(selectObjectTypesList);

  const onRemove = useCallback(
    (objects: TTEObject[]) => {
      const newIds = optionalRelations.filter((or) =>
        objects.every((object) => object.id !== or)
      );
      onChange({ optionalRelations: newIds });
    },
    [optionalRelations, onChange]
  );

  const onSelectedObjectsChange = useCallback(
    (objects: TTEObject[]) => {
      const newIds = [
        ...optionalRelations,
        ...objects.map((object) => object.id),
      ];

      // remove duplicates
      const uniqueIds = Array.from(new Set(newIds));
      onChange({ optionalRelations: uniqueIds });
    },
    [optionalRelations, onChange]
  );

  return (
    <Association
      tableId="objects.optionalRelated"
      objectIds={optionalRelations}
      objectTypes={allType}
      onChange={onSelectedObjectsChange}
      onRemove={onRemove}
      data-testid="opt-related"
      changedIds={dirtyFields?.optionalRelations}
    />
  );
};

export default OptionalRelated;
